<template>
  <form
    autocomplete="off"
    class="order-table-coupon-form"
    @submit.prevent="submit"
  >
    <div class="order-table-coupon-form__check hidden sm:block">Coupon/Gutschein</div>
    <div class="order-table-coupon-form__redeem">
      <span v-if="hasRedeemedCoupon"> Verwendeter Code: </span>
      <TextInput
        ref="couponInput"
        v-model.trim="fields.values.redeemedCoupon"
        :disabled="!isEditable"
        :error="fields.errors.redeemedCoupon?.[0]"
        :maxlength="15"
        inline-label
        class="order-table-coupon-form__redeem-field"
        label="Coupon/Gutschein"
      />
      <LinkButton
        v-if="!hasRedeemedCoupon"
        :disabled="!isSubmittable"
        data-tealium-rel="content.button.coupon"
        style="--padding-x: 6px"
        tag="button"
        type="submit"
      >
        Einlösen
      </LinkButton>
      <button
        v-else
        class="order-table-coupon-form__delete-btn"
        type="button"
        aria-label="Entferne den eingegebenen Gutschein"
        @click="deleteCoupon"
      >
        <SvgIcon
          class="order-table-coupon-form__delete-icon"
          :image="DeleteIcon"
        />
      </button>
    </div>
  </form>
</template>

<script>
import Form from '@/mixins/form';
import DeleteIcon from '@/assets/images/delete.svg';
import { LinkButton, TextInput } from '@i22-td-smarthome/component-library';
import { mapActions } from 'vuex';

export default {
  name: 'OrderTableCouponForm',
  mixins: [
    Form({
      redeemedCoupon: {
        required: true,
      },
    }),
  ],
  components: {
    LinkButton,
    TextInput,
  },
  data() {
    return {
      DeleteIcon,
    };
  },
  computed: {
    hasRedeemedCoupon() {
      if (!this.values) return false;
      return !!this.values.redeemedCoupon;
    },
    isEditable() {
      return !this.disabled && !this.isValidating && !this.hasRedeemedCoupon;
    },
  },
  methods: {
    ...mapActions('cart', ['deleteCoupon']),
    focusInput() {
      this.$refs?.couponInput?.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.order-table-coupon-form {
  display: inline-block;
  width: 100%;

  @include mq($mq-sm) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  &__check {
    margin-right: $grid-base;
  }

  &__input {
    padding-bottom: 0;
  }

  &__redeem {
    display: flex;
    gap: $grid-base;
    height: auto;
    align-items: center;
    @include mq($mq-sm) {
      height: auto;
    }

    &-field {
      width: 100%;
      @include mq($mq-sm) {
        width: auto;
      }
    }
  }

  &__delete-btn {
    background: none;
    border: none;
    cursor: pointer;
  }

  &__delete-icon {
    width: 24px;
    height: 24px;
  }
}
</style>
